import Reveal from './Reveal';

const steps = [
  {
    n: '01',
    head: 'Send your menu the way you already do',
    sub: 'Forward the supplier email to ingest@cannafax.ai from your account email, or upload your spreadsheet. Cannafax builds each listing with the COA, photo, quantity and price in one place.',
  },
  {
    n: '02',
    head: 'You choose who sees it',
    sub: 'Share a menu by link with named buyers or the brokers you work with, and switch it off anytime.',
  },
  {
    n: '03',
    head: 'Interest comes back to you',
    sub: 'Your Next Move™ lands in your inbox when a buyer or listing needs you — one move, one tap. Reply by email and it threads back into the conversation.',
  },
];

const HowItWorks = () => (
  <section id="how" className="scroll-mt-16 border-b border-border bg-background py-20 md:py-24">
    <div className="container-wide">
      <Reveal className="max-w-2xl">
        <h2 className="text-3xl font-semibold tracking-tight sm:text-4xl">
          How it works, in three moves
        </h2>
      </Reveal>

      <ol className="mt-12 grid gap-8 md:grid-cols-3">
        {steps.map((s, i) => (
          <Reveal as="li" key={s.n} delay={i * 100} className="list-none">
            <div className="relative pt-6">
              <span className="absolute left-0 top-0 h-px w-full bg-border" />
              <span className="absolute left-0 top-0 h-px w-10 bg-brand" />
              <p className="num-id text-sm text-brand-text">{s.n}</p>
              <p className="mt-3 text-lg font-medium leading-snug">{s.head}</p>
              <p className="mt-2 text-sm text-muted-foreground">{s.sub}</p>
            </div>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);

export default HowItWorks;